<div id="userdataJuncture" class="container">

  @if (this.DataService.connectionLinkType === 'PARTNERI' && !this.continueNow && contractIsOKToContinue() && !FlagService.flagServiceObject[4]['socsecurityJunctureFlag']) {
    <app-noworlater-juncture></app-noworlater-juncture>
  }

  @if (this.DataService.connectionLinkType !== 'PARTNERI' || this.continueNow || !contractIsOKToContinue()) {
    <div class="row">
      @if (!this.FlagService.flagServiceObject[6]['payfrequencyJunctureFlag']) {
        <div class="col-12 p-0">
          <div class="component-header __indicator">
            <h3 class="label m-0">{{ 'junctures.userData.header' | translate }}</h3>
          </div>
        </div>
      }
      @if (!this.FlagService.flagServiceObject[4]['socsecurityJunctureFlag']) {
        <div class="col-12">
          <div class="title">
            <fa-icon class="faUserTag" [icon]="faUserTag"></fa-icon>
            <h3>{{ 'junctures.userData.title' | translate }}</h3>
          </div>
        </div>
      }
      @if (!this.FlagService.flagServiceObject[4]['socsecurityJunctureFlag']) {
        <div class="input-group">
          <form id="userDataForm">
            <div class="col-12">
              <label class="form-label mt-0" for="preName">{{ 'junctures.userData.data.title' | translate }}</label>
              <input type="text" class="form-control" id="preName" name="pre-name" placeholder="{{ 'junctures.userData.data.title' | translate }}" [(ngModel)]="_preNameInput" (focus)="focusTitle$.next($any($event).target.value)" [ngbTypeahead]="searchTitle" />
              @if (_preNameInput?.length > 0) {
                <div>
                  @if (checkTitle()) {
                    <div class="feedback valid-feedback">{{ 'junctures.userData.data.ok' | translate }}</div>
                  }
                  @if (!checkTitle()) {
                    <div class="feedback invalid-feedback">{{ 'junctures.userData.data.choose' | translate }}</div>
                  }
                </div>
              }
              <label class="form-label" for="surName">{{ 'junctures.userData.data.surname' | translate }}</label>
              <input id="surName" class="form-control" type="text" name="sur-name" placeholder="{{ 'junctures.userData.data.surname' | translate }}" [(ngModel)]="_surNameInput" (ngModelChange)="nameChanged()" [ngClass]="{'required': (_surNameInput.length <= 0 && validationStarted)}" required>
              @if (validationStarted) {
                <div>
                  @if (_surNameInput.length > 0) {
                    <div class="feedback valid-feedback">{{ 'junctures.userData.data.ok' | translate }}</div>
                  }
                  @if (_surNameInput.length <= 0) {
                    <div class="feedback invalid-feedback">{{ 'junctures.userData.data.surnameMissing' | translate }}</div>
                  }
                </div>
              }
              <label class="form-label" for="foreName">{{ 'junctures.userData.data.givenName' | translate }}</label>
              <input id="foreName" class="form-control" type="text" name="fore-name" placeholder="{{ 'junctures.userData.data.givenName' | translate }}" [(ngModel)]="_foreNameInput" (ngModelChange)="nameChanged()" [ngClass]="{'required': (_foreNameInput.length <= 0 && validationStarted)}" required>
              @if (validationStarted) {
                <div>
                  @if (_foreNameInput.length > 0) {
                    <div class="feedback valid-feedback">{{ 'junctures.userData.data.ok' | translate }}</div>
                  }
                  @if (_foreNameInput.length <= 0) {
                    <div class="feedback invalid-feedback">{{ 'junctures.userData.data.givenNameMissing' | translate }}</div>
                  }
                </div>
              }
              @if (sameAsEmployee) {
                <div>
                  <div class="feedback invalid-feedback">{{ 'junctures.userData.data.sameAsEmployee' | translate }}</div>
                </div>
              }
              <div class="form-check">
                <input id="sameAsBirthName" class="form-check-input" type="checkbox" [(ngModel)]="_sameAsBirthName" (change)="sameAsBirthName()">
                <label class="form-check-label" for="sameAsBirthName">{{ 'junctures.userData.data.sameName' | translate }}</label>
              </div>
              <label class="form-label" for="birthName">{{ 'junctures.userData.data.birthName' | translate }}</label>
              <input id="birthName" class="form-control" type="text" name="birth-name" placeholder="{{ 'junctures.userData.data.birthName' | translate }}" [(ngModel)]="_birthNameInput" [ngClass]="{'required': (_birthNameInput.length <= 0 && validationStarted)}" required [attr.disabled]="_sameAsBirthName? true : null">
              @if (validationStarted) {
                <div>
                  @if (_birthNameInput.length > 0) {
                    <div class="feedback valid-feedback">{{ 'junctures.userData.data.ok' | translate }}</div>
                  }
                  @if (_birthNameInput.length <= 0) {
                    <div class="feedback invalid-feedback">{{ 'junctures.userData.data.birthNameMissing' | translate }}</div>
                  }
                </div>
              }
              <label class="form-label mt-4 pt-2">{{ 'junctures.userData.data.birthDate' | translate }}</label>
              <div>
                {{ _birthDateInput }}
              </div>
              <label class="form-label" for="placeBorn">{{ 'junctures.userData.data.birthPlace' | translate }}</label>
              <input id="placeBorn" class="form-control" type="text" name="place-born" placeholder="{{ 'junctures.userData.data.birthPlace' | translate }}" [(ngModel)]="_birthPlaceInput" [ngClass]="{'required': (_birthPlaceInput.length <= 0 && validationStarted)}" required>
              @if (validationStarted) {
                <div>
                  @if (_birthPlaceInput.length > 0) {
                    <div class="feedback valid-feedback">{{ 'junctures.userData.data.ok' | translate }}</div>
                  }
                  @if (_birthPlaceInput.length <= 0) {
                    <div class="feedback invalid-feedback">{{ 'junctures.userData.data.birthPlaceMissing' | translate }}</div>
                  }
                </div>
              }
              <label class="form-label" for="mothersName">{{ 'junctures.userData.data.mothersName' | translate }}</label>
              <input id="mothersName" class="form-control" type="text" name="mothers-name" placeholder="{{ 'junctures.userData.data.mothersName' | translate }}" [(ngModel)]="_mothersNameInput" [ngClass]="{'required': (_mothersNameInput.length <= 0 && validationStarted)}" required>
              @if (validationStarted) {
                <div>
                  @if (_mothersNameInput.length > 0) {
                    <div class="feedback valid-feedback">{{ 'junctures.userData.data.ok' | translate }}</div>
                  }
                  @if (_mothersNameInput.length <= 0) {
                    <div class="feedback invalid-feedback">{{ 'junctures.userData.data.mothersNameMissing' | translate }}</div>
                  }
                </div>
              }
              @if (_forChildren) {
                <label class="form-label" for="legalRepName">{{ 'junctures.userData.data.legalRep' | translate }}</label>
                <input id="legalRepName" class="form-control" type="text" name="lRep-name" placeholder="{{ 'junctures.userData.data.legalRep' | translate }}" [(ngModel)]="_legalRepNameInput" [ngClass]="{'required': (_legalRepNameInput.length <= 0 && validationStarted)}" required>
                @if (validationStarted) {
                  <div>
                    @if (_legalRepNameInput.length > 0) {
                      <div class="feedback valid-feedback">{{ 'junctures.userData.data.ok' | translate }}</div>
                    }
                    @if (_legalRepNameInput.length <= 0) {
                      <div class="feedback invalid-feedback">{{ 'junctures.userData.data.legalRepMissing' | translate }}</div>
                    }
                  </div>
                }
              }
            </div>
            <div class="d-flex summary mt-4">
              <div class="w-100">
                <fa-icon class="text-center me-2" [icon]="faUserTag"></fa-icon>
                <div class="text">
                  <span class="name">{{ _preNameInput }} {{ _surNameInput }} {{ _foreNameInput }}</span><br>
                  <span class="date">{{ _birthDateInput }}</span>
                </div>
              </div>
              <div class="flex-shrink-1">
                <button (click)="sendUserdata()" type="button" class="btn btn-light float-end">{{ 'common.ok' | translate }}</button>
              </div>
            </div>
          </form>
        </div>
      }
    </div>
  }

  @if (this.FlagService.flagServiceObject[4]['socsecurityJunctureFlag']) {
    <div class="row feedback-module" (click)="userdataJunctureClick()">
      <div class="d-flex p-0">
        <a class="w-100">
          <fa-icon class="text-center ms-3 me-3" [icon]="faUserTag"></fa-icon>
          <div class="text">
            <span class="top">{{ this.insurantData.insuredPerson.title }} {{ this.insurantData.insuredPerson.lastName }} {{ this.insurantData.insuredPerson.firstName }}</span><br>
            <span class="bottom">{{ this.insurantData.insuredPerson.birthDate }}</span>
          </div>
        </a>
        <div class="flex-shrink-1">
          <fa-icon class="faInfoCircle me-2" [icon]="faInfoCircle"></fa-icon>
        </div>
      </div>
    </div>
  }
</div>
